import type { IntlShape } from 'react-intl';
import { messages } from './messages';
import baseMessages from '@fhnw/messages/base';

export const schema = (props: { intl: IntlShape }) => {
  return {
    title: props.intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['href', 'iframe_view'],
      },
    ],
    properties: {
      href: {
        title: props.intl.formatMessage(messages.target),
        description:
          'Select an HTML snippet object. The content will not be rendered until you save the content',
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'UID'],
        selectableTypes: ['Snippet'],
        allowExternals: false,
      },
      iframe_view: {
        title: props.intl.formatMessage(baseMessages.iframe_view),
        description: props.intl.formatMessage(
          baseMessages.iframe_view_description,
        ),
        type: 'boolean',
        default: false,
      },
    },
    required: [],
  };
};
